import React from "react";
import { Link } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";
import { LinkText, Notifier, Typography } from "../ecosystem";
import * as msgs from "../../constants/textConstants";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class HeaderMessageBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //showBanner: (props.message != null && props.message != "") ? true : false
        };

        this.closeVersionBanner = this.closeVersionBanner.bind(this);
        this.updateVersionBanner = this.updateVersionBanner.bind(this);
    }

    closeVersionBanner() {
        this.props.hideNormalAppUpdate();
    }

    updateVersionBanner() {
        if (window) {
            window.location.reload(true);
        }
    }

    render() {
        const {
            hasHeaderMessage,
            headerMessage,
            serviceDownMessage,
            showAccordionButton,
            showHeaderMessage,
            showVersionUpdateBanner,
            showServiceDownBanner,
            toggleHeaderMessage,
            versionUpdateMessage,
            isMyChartInactivated,
            technicalHelpDeskNumber
        } = this.props;
        const bannerMessages = [];
        const className = 'header-message-banner-container';
        const colorStyle = !headerMessage && !showServiceDownBanner && !isMyChartInactivated ? 'alert' : 'error';
        const linkColor = colorStyle === 'error' ? '$color-primary-c1' : '$color-primary-a2';
        let icon = isMyChartInactivated || showServiceDownBanner ? "exclamation" : null

        if (hasHeaderMessage) {
            bannerMessages.push(<>
                <>{headerMessage}</>
            </>);
        }

        if (showVersionUpdateBanner) {
            bannerMessages.push(<>
                <>{showServiceDownBanner
                    ? <>Medical records are down for maintenance. However, an update is available for other parts of MyBSWHealth.</>
                    : versionUpdateMessage
                }
                </>
                <br className="mobile-element" />
                <Link className="banner-buttons__update" to="#" onClick={this.updateVersionBanner}><Typography type="body-01" color={linkColor}>Update</Typography></Link>
                <Link to="#" className="banner-buttons__skip" onClick={this.closeVersionBanner}><Typography type="body-01" color={linkColor}>Not Now</Typography></Link>
            </>);
        } else if (!showVersionUpdateBanner && showServiceDownBanner && !isMyChartInactivated) {
            bannerMessages.push(<>
                <>{serviceDownMessage}</>

            </>);
        }

        if (isMyChartInactivated) {
            bannerMessages.push(<>Some features are unavailable. To activate your medical record and access extended features in MyBSWHealth, call <LinkText
                className="call-number"
                href={"tel:" + technicalHelpDeskNumber}
                typographyType="body-01"
                display="inline-block"
                decorator="mobile"
                color="$color-primary-c1"
                underline="mobile"
                onClick={
                    () => {
                        logUI("MBHWeb.UI.HeaderMessageBanner.MyChartInActive.CallHelpDesk.Clicked", new Date(), Tools.getURLPath());
                    }
                }
            >
                {technicalHelpDeskNumber}.
            </LinkText></>);
        }

        const showAccordionBtn = (showAccordionButton || bannerMessages.length > 1);

        return (
            <React.Fragment>
                {showHeaderMessage &&
                    <Notifier
                        className={className}
                        colorStyle={colorStyle}
                        icon={icon}
                        show={showHeaderMessage}
                        variant="banner"
                    >
                        <ul>
                            {bannerMessages.map((msg, i) => {
                                return <li key={i} className={`${showAccordionBtn ? 'header-msg--accordion' : ''}`}>
                                    <div className={`header-msg`}>{msg}</div>
                                    {i === 0 && (showAccordionBtn) && <>
                                        <span className="header-msg-ellipsis">...</span><button type="button" className="btn btn-icon-only" onClick={() => toggleHeaderMessage()}><span className="icon-dd" /></button>
                                    </>}
                                </li>;
                            })}
                        </ul>
                    </Notifier>
                }
            </React.Fragment>
        );
    }
}

const defaultProps = {
    serviceDownMessage: 'We’re unable to open some of the features in MyBSWHealth. Please try again later if the issue persists.',
    toggleHeaderMessage: () => ({})
};

const mapStateToProps = (state) => {
    return {
        normalAppUpdateShow: state.header.normalAppUpdateShow,
        versionUpdateMessage: state.session && state.session.serverData && state.session.serverData.versionUpdateMessage ? state.session.serverData.versionUpdateMessage : 'A new version is available! Would you like to update to the newest version?',
        screenBreakPoint: state.common.screenBreakPoint,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : ""
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideNormalAppUpdate: () => dispatch({ type: types.HIDE_NORMAL_APP_UPDATE })
    };
};

HeaderMessageBanner.defaultProps = defaultProps;
export default connect(mapStateToProps, mapDispatchToProps)(HeaderMessageBanner);